import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Componentes
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import FriendlyPhrase from "../../components/FriendlyPhrase/FriendlyPhrase";
import UploadPlanilha from "../../components/Leitor/UploadPlanilha";
import PDFResumoCategorias from "../../components/GeneratorPJ/PDFGeneratorPJ"; // caminho original mantido
import ErrorBoundary from "../../components/Error/ErrorBoundary";

// Contextos
import { useLoader } from "../../contexts/LoaderContext";

// Estilos
import styles from "./pdfgeneratorpage.module.css";

function PDFGeneratorPage() {
  const [tipo, setTipo] = useState(null);
  const [consolidado, setConsolidado] = useState(null);
  const [dataEntry, setDataEntry] = useState([]);
  const [dataLeave, setDataLeave] = useState([]);

  const [dataMentor, setDataMentor] = useState({ entrada: [], saida: [] });

  const [mostrarPDFResumo, setMostrarPDFResumo] = useState(false);
  const [programa, setPrograma] = useState("");
  const [empresa, setEmpresa] = useState("");

  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const handleBack = () => navigate(-1);

  useEffect(() => {
    if ((consolidado && dataEntry.length > 0 && dataLeave.length > 0) ||
        (!consolidado && dataEntry.length > 0)) {
      setMostrarPDFResumo(true);
    } else {
      setMostrarPDFResumo(false);
    }
  }, [dataEntry, dataLeave, consolidado]);

  return (
    <div className={styles.PDFGeneratorPage}>
      <div className={styles.containerTop}>
        <div className={styles.containerTopLeft}>
          <Breadcrumbs />
          <h1 className={styles.title}>Gerador de PDFs</h1>
          <FriendlyPhrase page="pdfGenerator" />
        </div>

        <div className={styles.tipoSelectorDiv}>
          <h1 className={styles.title}>Selecione uma opção</h1>
          <div className={styles.tipoSelector}>
            <button onClick={() => setTipo("PF")} disabled={tipo === "PF"}>
              Pessoa Física (PF)
            </button>
            <button onClick={() => setTipo("PJ")} disabled={tipo === "PJ"}>
              Pessoa Jurídica (PJ)
            </button>
          </div>
        </div>
      </div>

      <ErrorBoundary>
        {tipo ? (
          <div className={styles.uploadAndPdfWrapper}>
            <UploadPlanilha
              PJ={tipo === "PJ"}
              onEntryDataProcessed={setDataEntry}
              onLeaveDataProcessed={setDataLeave}
              onMentorDataProcessed={setDataMentor}
              setPrograma={setPrograma}
              setEmpresa={setEmpresa}
              setConsolidado={setConsolidado}
              showLoader={showLoader}
              hideLoader={hideLoader}
            />

            {mostrarPDFResumo && (
              <PDFResumoCategorias
                entrada={dataEntry}
                saida={dataLeave}
                mentorEntrada={dataMentor.entrada}
                mentorSaida={dataMentor.saida}
                PJ={tipo === "PJ"}
                programa={programa}
                empresa={empresa}
                consolidado={consolidado}
                onFinalizado={() => setMostrarPDFResumo(false)}
                showLoader={showLoader}
                hideLoader={hideLoader}
              />
            )}
          </div>
        ) : (
          <div className={styles.containerEmptyMessage}>
            <p className={styles.emptyMessageTop}>Tipo não selecionado.</p>
            <p className={styles.emptyMessageBottom}>Escolha uma opção!</p>
          </div>
        )}
      </ErrorBoundary>
    </div>
  );
}

export default PDFGeneratorPage;